import type { Brand } from '~/modules/branding/types';

/**
 * Returns an object containing default Event properties for Analytics tracking.
 * These properties will be used for each event that is tracked in the Container.
 * @param brand - The Brand object to get information from.
 */
export function getDefaultEventProperties(brand: Brand) {
  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
  //
  //    ▄▄▄▖  ▗▖  ▗▖  ▗▄▄▖   ▗▄▖  ▗▄▄▖  ▗▄▄▄▖  ▗▄▖  ▗▖  ▗▖  ▗▄▄▄▖   ▐▌
  //     █    ▐▛▚▞▜▌  ▐▌ ▐▌ ▐▌ ▐▌ ▐▌ ▐▌   █   ▐▌ ▐▌ ▐▛▚▖▐▌    █     ▐▌
  //     █    ▐▌  ▐▌  ▐▛▀▘  ▐▌ ▐▌ ▐▛▀▚▖   █   ▐▛▀▜▌ ▐▌ ▝▜▌    █     ▐▌
  //    ▄█▄▖  ▐▌  ▐▌  ▐▌    ▝▚▄▞▘ ▐▌ ▐▌   █   ▐▌ ▐▌ ▐▌  ▐▌    █     ▗▖
  //
  //    These properties are tracked for ALL events in ALL applications
  //    (e.g. - WMG1, ADA, etc.).
  //
  //    DO NOT REMOVE ANYTHING FROM HERE WITHOUT FIRST CHECKING WITH THE TEAM!
  //
  //    At a bare mininm ask in the relevant channel (#ada-wmg1-amplitude-collab)
  //    so that everyone is aware of the potential change.
  //
  //    These values are more than likely being used for analytics and any
  //    changes can have huge effects on the data being collected/reported.
  //
  // !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!

  return {
    product: brand.product,
  };
}
